import apiClient from './apiClient';

export interface ProgramIssue {
  code: string;
  sheet: string;
  row: number;
  value: string;
}

export interface ProgramImportBatch {
  id: string;
  event_id: string;
  state: 'validated' | 'confirmed' | 'rejected';
  summary: Record<string, number>;
  sessions: Array<{ source_key: string; title: string; type: string; date: string; room: string | null; start_time: string | null; end_time: string | null; items: unknown[] }>;
  issues: ProgramIssue[];
  conflicts?: Array<{ entity: string; source_key: string; current: { title?: string }; proposed: { title?: string } }>;
  suggested_interests: string[];
}

export const programImportService = {
  latest(eventId: string): Promise<ProgramImportBatch | null> {
    return apiClient.get<ProgramImportBatch | null>(`/admin/events/${eventId}/program-imports/latest?state=validated`);
  },
  preview(eventId: string, file: File): Promise<ProgramImportBatch> {
    const form = new FormData();
    form.append('file', file);
    return apiClient.upload<ProgramImportBatch>(`/admin/events/${eventId}/program-imports/preview`, form);
  },
  commit(eventId: string, batchId: string, skipIssueRows: number[], keepCurrentSourceKeys: string[] = []): Promise<ProgramImportBatch> {
    return apiClient.post<ProgramImportBatch>(`/admin/events/${eventId}/program-imports/${batchId}/commit`, { skip_issue_rows: skipIssueRows, keep_current_source_keys: keepCurrentSourceKeys });
  },
};
